<!-- Capterra tracking -->
<img src="https://ct.capterra.com/capterra_tracker.gif?vid=2354772&vkey=5b1cceec36aca6ef093caaf3e235fee9" alt="" />

<lib-card [title]="'Success'" [cardIcon]="'done'">
	<div>Your account is ready to be used. Feel free to contact us using the built-in if you have any questions.</div>
	<div class="push-top">
		<lib-button-list [buttons]="successCardButtons()"></lib-button-list>
	</div>
</lib-card>

<h2 class="push-top">Explore sample data</h2>
<div class="push-top" [libFlexRow]="isMobileOrTabletView()" [libFlexRowAlign]="'center'">
	@for(sampleItem of sampleItems(); track sampleItem.title) {
	<div libFlexColumn [libFlexSize]="isMobileOrTabletView() ? 'full' : 'fill'">
		<lib-card class="w-centered">
			<div libFlexRow [libFlexRowAlign]="'center'">
				<div libFlexColumn [libFlexSize]="'150px'">
					<lib-image
						[imageSize]="'250px'"
						[maxWidth]="150"
						[image]="sampleItem.avatar"
						[alt]="'Sample data'"
						[avatarName]="sampleItem.title"
					></lib-image>
				</div>
			</div>

			<div class="push-top">
				<h3>
					{{ sampleItem.title }}
				</h3>
				<div libText3>
					{{ sampleItem.text }}
				</div>
			</div>
			<div class="push-top" libFlexRow [libFlexRowAlign]="'center'">
				<div libFlexColumn>
					<lib-button [routerLink]="sampleItem.routerLink">View</lib-button>
				</div>
			</div>
		</lib-card>
	</div>
	}
</div>

<div class="push-top">
	<lib-button-list [buttons]="dashboardButtons()"></lib-button-list>
</div>
